import { commonPermissions, tabsPermissions } from './constants'

export const canLoadNavigation = (permissions: any[]): boolean => {
  const tabsPermission = [...Object.values(tabsPermissions)]

  return !(
    permissions['BIC_WIZARD'] !== true ||
    commonPermissions.some((key) => permissions[key] !== true) ||
    tabsPermission.every((tab) => tab.some((key) => permissions[key] !== true))
  )
}
